<template>
  <div id="password-reset-confirm-view">
    <v-content>
      <v-container>
        <v-layout justify-center row wrap>
          <v-flex xs12 sm8 md6>
            <v-card 
              max-width="800px"
              elevation=24
            >
              <v-toolbar dark color="primary">
                <v-toolbar-title>{{ title }}</v-toolbar-title>
              </v-toolbar>
              
              <v-layout align-center justify-center row fill-height>
                <router-link to="/">
                  <img :src="require('../assets/fuzzcv-logo.png')" alt="fuzzcv curriculum vitae CV automatique en ligne" width="400" class="mt-3">
                </router-link>
              </v-layout>
              <v-card-text class="subheading">
                {{ explainText }}
              </v-card-text>

              <v-layout align-center justify-center row fill-height
                        v-if="resetLoading">
                <v-progress-circular
                  :size="70"
                  :width="7"
                  indeterminate
                  color="primary"
                  class="text-xs-center mb-5"
                ></v-progress-circular>
              </v-layout>
              <v-form 
                v-else-if="!resetCompleted">
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-text-field v-model="inputs.new_password1" v-bind:label=labelPassword1 type="password" required></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field v-model="inputs.new_password2" v-bind:label=labelPassword2 type="password" required></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-layout wrap>
                    <v-flex xs12>
                      <div class="mb-3">
                        <v-alert v-show="resetError"
                                 :value="true"
                                 type="warning"
                                 class="mb-2"
                        >
                          {{ resetErrorRaison }}
                        </v-alert>
                      </div>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-layout align-center justify-space-between row fill-height>
                      <v-btn color="info" @click="resetPassword(inputs)">{{ buttonLabel }}</v-btn>
                      <small>{{ required_fields }}</small>
                    </v-layout>
                    
                  </v-layout>
                </v-card-actions>
              </v-form>
              <v-card-text v-else> 
                <v-flex xs12>
                  <div class="mt-3">
                    <v-alert
                      :value="true"
                      type="success"
                    >
                      {{ successMsg }}
                    </v-alert>
                    <div>
                      <router-link to="/login">{{ backToPageLabel }}</router-link>
                    </div>
                  </div>
                </v-flex>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </div>
</template>

<script>
 import { mapActions, mapState } from 'vuex';

 export default {
   data() {
     return {
       title: "Definir un nouveau mot de passe.",
       explainText: "Veuillez définir votre nouveau mot de passe ci-dessous :",
       labelPassword1: "Mot de passe*",
       labelPassword2: "Confirmer mot de passe*",
       buttonLabel: "Changer le mot de passe",
       backToPageLabel: "Retourner à la page de login.",
       errorMsg: "Une erreur s'est produite pendant le traitement de votre requête.",
       successMsg: `Votre mot de passe a été changé.`,
       required_fields: `*Champs requis`,
       inputs: {
         new_password1: '',
         new_password2: '',
         uid: this.$route.params.uid,
         token: this.$route.params.token,
       },
     };
   },
   computed: mapState('password', [
     'resetCompleted',
     'resetError',
     'resetLoading',
     'resetErrorRaison',
   ]),
   methods: mapActions('password', [
     'resetPassword',
     'clearResetStatus',
   ]),
   beforeRouteLeave(to, from, next) {
     console.log("On PARSSSSSS")
     this.clearResetStatus();
     next();
   },
   created: function () {
     // `this` points to the vm instance
     this.clearResetStatus();
   }
 };
</script>

<style>
 #password-reset-confirm-view {
     background-image: url('../assets/hands-joined-team.jpg');
     /* background-color: #8f2c2c; */
     height: 100vh;
     background-position: center;
     background-repeat: no-repeat;
     background-size: cover;
     position: relative;
 }
</style>
